import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { ConfigService } from '../../shared/services/config.service';
import { UserService } from '../../shared/services/user.service';
import { ApiBaseService } from './api-base.service';
import { catchError } from "rxjs/operators";
import { Tilestat } from "../../modules/production/_api/models/tilestat.model";
import { Equipment } from '../models/equipment.model';

@Injectable({
  providedIn: 'root'
})
export class CarrierItemFlowService extends ApiBaseService {

  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", APIKEY: "ams-direct-api-project-key", SessionId: this.userService.sessionId }) };
    this.baseUrl = `${this.configService.config.projectUrl}/api/carrieritemflows`;
  }

  getByTime(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/GetByTimeId?timeId=${id}`, this.httpOptions)
      .pipe(catchError(this.handleError<any[]>("Failed to get carrier item flows", [])));
  }

  getByTimeEmployeeWithinPeriod(timeId: number, employeeId: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<any[]> {
    const request = { "TimeId": timeId, "EmployeeId": employeeId, "FromDate": fromDate, "ToDate": toDate };

    return this.http.post<any[]>(`${this.baseUrl}/getbytimeandemployeewithinperiod`, request, this.httpOptions)
      .pipe(catchError(this.handleError<any>(`Failed to get carrier item flows`)));
  }

  getArticles(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/GetAllArticles`, this.httpOptions)
      .pipe(catchError(this.handleError<any[]>("Failed to get articles", [])));
  }

  saveMultipleCarrierItems(itemsToAddOrUpdate: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/AddOrUpdateMultipleCarrierItemFlows', itemsToAddOrUpdate, this.httpOptions);
  }

  deleteByIds(ids: number[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/DeleteCarrierItemFlows`, ids, this.httpOptions); 
  }
}
